import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { schedule } from '@ember/runloop';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import JournalService from 'donor-elf-web/services/journal-service';

export default class ContactIndexRoute extends Route {
  @service declare navbarSettings: NavbarSettingsService;
  @service declare journalService: JournalService;

  queryParams = {
    filters: {
      replace: true,
    },
    filtersInitiallyOpened: {
      replace: true,
    },
  };

  async model() {
    await this.journalService.load();
  }

  beforeModel() {
    schedule('render', this, () => {
      this.navbarSettings.enableFluidContainer = true;
    });
    this.navbarSettings.title = 'Contacts';
  }

  deactivate() {
    this.navbarSettings.enableFluidContainer = false;
  }
}
